module.exports = __webpack_public_path__ + "img/logo.4d7c7c67.png";